import { render, staticRenderFns } from "./RequestPriorityField.vue?vue&type=template&id=2da339a0&scoped=true&"
import script from "./RequestPriorityField.vue?vue&type=script&lang=js&"
export * from "./RequestPriorityField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da339a0",
  null
  
)

export default component.exports
import {QSelect,QIcon} from 'quasar'
component.options.components = Object.assign({QSelect,QIcon}, component.options.components || {})
